import './ListAOs.scss';

import { Favorite, FavoriteBorder } from '@mui/icons-material';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';
import { Button, IconButton } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {  useLocation, useNavigate } from 'react-router-dom';

import CategoriesSubCategoriesDropDown from '../../../Components/CategoriesSubCategoriesDropDown';
import { buttonStyles } from '../../../Components/docsAdministrative/JsObjectStyles';
import { TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import SearchCity from '../../../Components/shared/SearchCity';
import {  modeTravailEnum } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import usePostRequest from '../../../hooks/usePostRequest';
// import useRefreshToken from '../../../hooks/useRefreshToken';
import useRole from '../../../hooks/useRole';
import useWindowSize from '../../../hooks/useWindowSize';
import { getEntrepriseInfoRoleBased, searchLabelInEnumByValue } from '../../../Utils/utils';
import imgConfidentielle from './imageConfidentielle.png';
import imgNotAvailable from './imageNotAvailable.png';
const ListAOsFavoris = () => {

    const axiosPrivate = useAxiosPrivate();

    // ! when the CORS error wfixed : in case of refresh token expired
    const navigate = useNavigate();
    // const { data:expertInfos, refresh } = useGetRequest({ url: 'expert/getMyInfos' });
    const [expertAoFav, setExpertAoFav ] = useState([]);
    const { postDataSilently } = usePostRequest();
    console.log('expertAoFav',expertAoFav);
    // const refresh = useRefreshToken();
    const role = useRole();
    const [localisation, setLocalisation] = useState();
    const [categorie, setCategorie] = useState('');
    const {pathname}=useLocation();
    const [sousCategorie, setSousCategorie] = useState('');
    const [simpleSearch, setSimpleSearch] = useState('');
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    // * pagination frontend starts here
    const [pageNumber, setPageNumber] = useState(0);
    const [numberOfPages, setNumberOfPages] = useState(0);
    const [aos, setAos] = useState([]);
    const pages = useMemo(() => new Array(numberOfPages).fill(null).map((v, i) => i), [numberOfPages]);

    useEffect(() => {
        // alert(pageNumber);
        getMyAOsFavoris();
    }, [pageNumber]);

    useEffect(() => {
        getMyAOsFavoris();//{search: simpleSearch, categorie,sousCategorie,localisation}
    }, [sousCategorie, categorie, localisation, simpleSearch]);

    const gotoPrevious = () => {
        setPageNumber(Math.max(0, pageNumber - 1));
    };
    const gotoNext = () => {
        setPageNumber(Math.min(numberOfPages - 1, pageNumber + 1));
    };

    const searchUserStep = async () => {
        if(role){
            try {
                const response = await axiosPrivate.get(`${role}/getMyInfos`);
                if(role=='expert')
                    setExpertAoFav(response?.data?.expert?.AOsFavoris);
                if(role=='esn')
                    setExpertAoFav(response?.data?.collaboratorEsn?.AOsFavoris);
            } catch (error) {
                console.log(error);
            }
        }
    };

    useEffect(() => {
        if(role)
            searchUserStep();
    }, [role]);

    useEffect(() => {
        if(expertAoFav)
            console.log('expertAoFav',expertAoFav);
    }, [expertAoFav]);

    const handleInitialiseSearch = () => {
        // old
        // setAos(aosOrigin);
        setSousCategorie('');
        setCategorie('');
        setLocalisation('');
        setSimpleSearch('');
        getMyAOsFavoris();
    };

    //* ///////*///\\\\\\\\\\\\*\\\\  *\\
    const selectAO = async (id) => {
        navigate('/expert/ao/' + id);
    };

    const getMyAOsFavoris = async () => {//{search,categorie,sousCategorie,localisation}
        try {
            const response = await axiosPrivate.get(`/ao/getMyAOsFavoris?page=${pageNumber}&search=${simpleSearch ?? ''}&sousCategorie=${sousCategorie ?? ''}&categorie=${categorie ?? ''}&localisation=${localisation ?? ''}`, {
                // signal: controller.signal
            });
            //?  if is mounted==true do next [setUsers..]
            let temp = response.data?.AOs;
            setAos(temp);
            // setAosOrigine(temp);
            setNumberOfPages(response.data?.totalPages);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <div className='HomeFrame'>
                <div className='frame5Profile'>{pathname.includes('aosHTH')?i18n.t('Appels d\'offres HTH'):i18n.t('Appels d\'offres')} &gt; <span style={{ color: 'rgba(39, 45, 60, 1)' }}> {i18n.t('Mes favoris')} </span> </div>
                <div className='HomeFrameTitle'>
                    <h1 className='TitleHStyle'>{i18n.t('Appels d\'offres favoris')} </h1>
                </div>

                <div className='HomeFrameSearch'>
                    {device=='desktop' &&
                        <IconButton
                            onClick={handleInitialiseSearch}
                        //className='initialise'
                        >
                            <RefreshIcon />
                        </IconButton>
                    }
                    <div className='subCategorieListAOs'>
                        <CategoriesSubCategoriesDropDown
                            //setSousCategorie={setSousCategorie}
                            setCategorie={setCategorie}
                            setSousCategorie={setSousCategorie}
                            sousCategorie={sousCategorie}
                            width={'100%'}
                            label={i18n.t('Catégories')}
                        />
                    </div>
                    <div className='serchFieldListAos'>
                        <TextFieldComponent
                            //className="nosubmit"
                            type="search"
                            sx={{
                                '& > :not(style)': { borderRadius: '8px' },
                            }}
                            style={{ width: '100%' }}
                            placeholder="Search here"
                            onChange={(e) => {
                                setSimpleSearch(e.target.value);
                                // handleSearch(e.target.value);
                            }}
                            value={simpleSearch}
                        />
                    </div>
                    {device=='desktop' &&
                    <>
                        <div className='searchCityListAos'>
                            <SearchCity
                                setCity={setLocalisation}
                                city={localisation}
                                width={'100%'}
                                label='Ville'
                            />
                        </div>
                    </>
                    }
                    {device!='desktop' &&
                        <div style={{display:'flex',flexDirection:'row',gap:'8px',width:'100%'}}>
                            <div className='searchCityListAos'>
                                <SearchCity
                                    setCity={setLocalisation}
                                    city={localisation}
                                    width={'100%'}
                                    label='Ville'
                                />
                            </div>
                            <IconButton
                                onClick={handleInitialiseSearch}
                            //className='initialise'
                            >
                                <RefreshIcon />
                            </IconButton>
                        </div>
                    }

                </div>

                <h5 className='HomeFrameAos'>
                    {i18n.t('Tous les appels d\'offres')}
                </h5>

                <div className='HomeAos'>
                    {aos?.length
                        ? (
                            <>
                                {aos.map((ao, i) => (
                                    <div
                                        key={i}
                                        className='cardStyleListAos'

                                    >
                                        <div className='Frame1'>
                                            <div className='F11'>

                                                <img
                                                    src={(ao?.entrepriseData?.nomEntrepriseConfidentiel==true)? imgConfidentielle : (ao?.companyDataId?.profileEntreprise?.logo !== undefined ? imgNotAvailable : ao?.companyDataId?.profileEntreprise?.logo )}
                                                    className='AOImage'
                                                    //to ASK REDA
                                                    //src={getEntrepriseInfoRoleBased({
                                                    //    info2Display:ao?.companyDataId?.profileEntreprise.logo,
                                                    //    isVisible2Expert: !(ao?.entrepriseData?.nomEntrepriseConfidentiel),
                                                    //    role: role
                                                    //})}
                                                    height="40"
                                                    alt='logoEntreprise'
                                                />

                                                <div
                                                    className='AOintitule'
                                                    onClick={() => selectAO(ao?._id)}
                                                >
                                                    <h3 className='TitreAO'>{ao?.intitulePoste || '_______'}</h3>
                                                    <p className='textIconsStyle'>
                                                        {
                                                            getEntrepriseInfoRoleBased({
                                                                info2Display: ao?.entrepriseData?.entrepriseName || ao?.companyDataId?.profileEntreprise?.nom,
                                                                isVisible2Expert: !(ao?.entrepriseData?.nomEntrepriseConfidentiel),
                                                                role: (role=='esn' ? 'esnExpert': role)
                                                            })
                                                        } | {i18n.t('Réf:')}{' '}
                                                        {ao.aoId}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className='F12' >
                                                <div
                                                    style={{
                                                        width: '24px',
                                                        height: '24px',
                                                    }}
                                                >
                                                    <svg
                                                        //width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <g clipPath="url(#clip0_885_43912)">
                                                            <path
                                                                d="M17.625 5.5H16.2188V4.09375C16.2188 3.63672 15.832 3.25 15.375 3.25C14.9531 3.25 14.5312 3.63672 14.5312 4.09375V5.5H9.46875V4.09375C9.46875 3.63672 9.08203 3.25 8.625 3.25C8.13281 3.25 7.78125 3.63672 7.78125 4.09375V5.5H6.375C5.10938 5.5 4.125 6.51953 4.125 7.75V19C4.125 20.2656 5.10938 21.25 6.375 21.25H17.625C18.8555 21.25 19.875 20.2656 19.875 19V7.75C19.875 6.51953 18.8555 5.5 17.625 5.5ZM17.625 19.5625H6.375C6.05859 19.5625 5.8125 19.3164 5.8125 19V10H18.1875V19C18.1875 19.3164 17.9062 19.5625 17.625 19.5625Z"
                                                                fill="#272D3C"
                                                            />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_885_43912">
                                                                <rect
                                                                    width="24"
                                                                    height="24"
                                                                    fill="white"
                                                                />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </div>
                                                <p
                                                    className='textIconsStyle'
                                                >
                                                    {
                                                        new Date(ao?.dateDebutAO)?.toLocaleDateString('en-GB') == 'Invalid Date'
                                                            ? '_______' : new Date(ao?.dateDebutAO)?.toLocaleDateString('en-GB')}</p>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'stretch', gap: '6px' }}>
                                            <p className='TextFrame21'>
                                                {i18n.t('A répondre avant')}
                                            </p>
                                            <div style={{ display: 'flex', flexDirection: 'row', gap: '24px',flexWrap:'wrap' }}>
                                                <div className='Frame21Date'>
                                                    <svg
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <g clipPath="url(#clip0_885_43912)">
                                                            <path
                                                                d="M17.625 5.5H16.2188V4.09375C16.2188 3.63672 15.832 3.25 15.375 3.25C14.9531 3.25 14.5312 3.63672 14.5312 4.09375V5.5H9.46875V4.09375C9.46875 3.63672 9.08203 3.25 8.625 3.25C8.13281 3.25 7.78125 3.63672 7.78125 4.09375V5.5H6.375C5.10938 5.5 4.125 6.51953 4.125 7.75V19C4.125 20.2656 5.10938 21.25 6.375 21.25H17.625C18.8555 21.25 19.875 20.2656 19.875 19V7.75C19.875 6.51953 18.8555 5.5 17.625 5.5ZM17.625 19.5625H6.375C6.05859 19.5625 5.8125 19.3164 5.8125 19V10H18.1875V19C18.1875 19.3164 17.9062 19.5625 17.625 19.5625Z"
                                                                fill="#272D3C"
                                                            />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_885_43912">
                                                                <rect
                                                                    width="24"
                                                                    height="24"
                                                                    fill="white"
                                                                />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>

                                                    <p
                                                        className='textIconsStyle'
                                                    >
                                                        {
                                                            new Date(ao?.dateFinAO)?.toLocaleDateString('en-GB') == 'Invalid Date'
                                                                ? '_______' :
                                                                new Date(ao?.dateFinAO)?.toLocaleDateString('en-GB')}
                                                    </p>
                                                </div>

                                                <div className='vectorLO'>

                                                </div>
                                                <div className='Frame22LO'>
                                                    <AccessTimeOutlinedIcon />
                                                    <p className='textIconsStyle'> {ao?.dureeMission ? ao?.dureeMission + ' jours' : 'Non précisé'} </p>
                                                </div>
                                                <div className='vector2LO'>

                                                </div>
                                                <div className='Frame23AO'>
                                                    <svg
                                                        width="18"
                                                        height="19"
                                                        viewBox="0 0 18 19"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M6.1875 3.41406C6.22266 3.44922 6.25781 3.51953 6.36328 3.625C6.36328 3.625 6.39844 3.625 6.39844 3.66016C5.73047 3.66016 5.09766 3.69531 4.5 3.80078V3.34375C4.5 2.71094 4.81641 2.21875 5.23828 1.86719C5.625 1.48047 6.15234 1.19922 6.75 0.988281C7.94531 0.53125 9.52734 0.25 11.25 0.25C12.9375 0.25 14.5195 0.53125 15.7148 0.988281C16.3125 1.19922 16.8398 1.48047 17.2266 1.86719C17.6484 2.21875 18 2.71094 18 3.34375V10.6562C18 11.2891 17.6484 11.8164 17.2266 12.168C16.8398 12.5547 16.3125 12.8359 15.7148 13.0469C15.3633 13.1875 15.0117 13.293 14.625 13.3984V11.6406C14.8008 11.6055 14.9414 11.5352 15.1172 11.4648C15.5742 11.2891 15.9258 11.1133 16.1016 10.9375C16.207 10.832 16.2422 10.7617 16.2773 10.7266C16.3125 10.6914 16.3125 10.6562 16.3125 10.6562V9.14453C16.1016 9.25 15.9258 9.32031 15.7148 9.39062C15.3633 9.53125 15.0117 9.63672 14.625 9.74219V7.98438C14.8008 7.94922 14.9414 7.87891 15.1172 7.80859C15.5742 7.63281 15.9258 7.45703 16.1016 7.28125C16.207 7.17578 16.2422 7.10547 16.2773 7.07031C16.2773 7.03516 16.2773 7.03516 16.3125 7V5.48828C16.1016 5.59375 15.9258 5.66406 15.7148 5.73438C15.2227 5.91016 14.6602 6.08594 14.0977 6.19141C13.8867 5.91016 13.7109 5.69922 13.5 5.52344C13.1484 5.20703 12.7266 4.92578 12.3047 4.71484C13.3945 4.64453 14.3789 4.43359 15.1172 4.15234C15.5742 3.97656 15.9258 3.80078 16.1016 3.625C16.207 3.51953 16.2422 3.44922 16.2773 3.41406C16.2773 3.37891 16.2773 3.37891 16.3125 3.34375C16.3125 3.34375 16.3125 3.34375 16.2773 3.30859C16.2422 3.27344 16.207 3.20312 16.1016 3.09766C15.9258 2.92188 15.5742 2.74609 15.1172 2.57031C14.168 2.18359 12.7969 1.9375 11.25 1.9375C9.66797 1.9375 8.29688 2.18359 7.34766 2.57031C6.89062 2.74609 6.53906 2.92188 6.36328 3.09766C6.25781 3.20312 6.22266 3.27344 6.1875 3.30859C6.15234 3.34375 6.15234 3.34375 6.15234 3.34375C6.1875 3.37891 6.1875 3.37891 6.1875 3.41406ZM0 7.84375C0 7.21094 0.316406 6.71875 0.738281 6.36719C1.125 5.98047 1.65234 5.69922 2.25 5.48828C3.44531 5.03125 5.02734 4.75 6.75 4.75C8.4375 4.75 10.0195 5.03125 11.2148 5.48828C11.8125 5.69922 12.3398 5.98047 12.7266 6.36719C13.1484 6.71875 13.5 7.21094 13.5 7.84375V15.1562C13.5 15.7891 13.1484 16.3164 12.7266 16.668C12.3398 17.0547 11.8125 17.3359 11.2148 17.5469C10.0195 18.0039 8.4375 18.25 6.75 18.25C5.02734 18.25 3.44531 18.0039 2.25 17.5469C1.65234 17.3359 1.125 17.0547 0.738281 16.668C0.316406 16.3164 0 15.7891 0 15.1562V7.84375ZM1.6875 7.91406C1.72266 7.94922 1.75781 8.01953 1.86328 8.125C2.03906 8.30078 2.39062 8.47656 2.84766 8.65234C3.79688 9.03906 5.16797 9.25 6.75 9.25C8.29688 9.25 9.66797 9.03906 10.6172 8.65234C11.0742 8.47656 11.4258 8.30078 11.6016 8.125C11.707 8.01953 11.7422 7.94922 11.7773 7.91406C11.7773 7.87891 11.7773 7.87891 11.8125 7.84375C11.8125 7.84375 11.8125 7.84375 11.7773 7.80859C11.7422 7.77344 11.707 7.70312 11.6016 7.59766C11.4258 7.42188 11.0742 7.24609 10.6172 7.07031C9.66797 6.68359 8.29688 6.4375 6.75 6.4375C5.16797 6.4375 3.79688 6.68359 2.84766 7.07031C2.39062 7.24609 2.03906 7.42188 1.86328 7.59766C1.75781 7.70312 1.72266 7.77344 1.6875 7.80859C1.65234 7.84375 1.65234 7.84375 1.6875 7.84375C1.6875 7.87891 1.6875 7.87891 1.6875 7.91406ZM11.8125 9.98828C11.6016 10.0938 11.4258 10.1641 11.2148 10.2344C10.0195 10.6914 8.4375 10.9375 6.75 10.9375C5.02734 10.9375 3.44531 10.6914 2.25 10.2344C2.03906 10.1641 1.86328 10.0938 1.6875 9.98828V11.5C1.6875 11.5352 1.6875 11.5352 1.6875 11.5703C1.72266 11.6055 1.75781 11.6758 1.86328 11.7812C2.03906 11.957 2.39062 12.1328 2.84766 12.3086C3.79688 12.6953 5.16797 12.9062 6.75 12.9062C8.29688 12.9062 9.66797 12.6953 10.6172 12.3086C11.0742 12.1328 11.4258 11.957 11.6016 11.7812C11.707 11.6758 11.7422 11.6055 11.7773 11.5703C11.7773 11.5352 11.7773 11.5352 11.8125 11.5V9.98828ZM2.25 13.8906C2.03906 13.8203 1.86328 13.75 1.6875 13.6445V15.1562C1.65234 15.1562 1.65234 15.1914 1.6875 15.2266C1.72266 15.2617 1.75781 15.332 1.86328 15.4375C2.03906 15.6133 2.39062 15.7891 2.84766 15.9648C3.79688 16.3516 5.16797 16.5625 6.75 16.5625C8.29688 16.5625 9.66797 16.3516 10.6172 15.9648C11.0742 15.7891 11.4258 15.6133 11.6016 15.4375C11.707 15.332 11.7422 15.2617 11.7773 15.2266C11.8125 15.1914 11.8125 15.1562 11.8125 15.1562V13.6445C11.6016 13.75 11.4258 13.8203 11.2148 13.8906C10.0195 14.3477 8.4375 14.5938 6.71484 14.5938C5.02734 14.5938 3.44531 14.3477 2.25 13.8906Z"
                                                            fill="#272D3C"
                                                        />
                                                    </svg>
                                                    <p className='textIconsStyle'>
                                                        {getEntrepriseInfoRoleBased({
                                                            info2Display: ao?.tjMax,
                                                            isVisible2Expert: ao?.visibilityTjMax,
                                                            role: (role=='esn' ? 'esnExpert': role)
                                                        }) ? getEntrepriseInfoRoleBased({
                                                                info2Display: ao?.tjMax,
                                                                isVisible2Expert: ao?.visibilityTjMax,
                                                                role: (role=='esn' ? 'esnExpert': role)
                                                            }) + ' €' : 'Non précisé'}
                                                    </p>
                                                </div>
                                                <div className='vector3LO'>
                                                </div>
                                                <div className='Frame24AO'>
                                                    <RoomOutlinedIcon />
                                                    <p className='textIconsStyle'> {ao?.localisation || 'Non précisé'} {ao?.modeTravail?.type ? ',' : ''} {i18n.t(searchLabelInEnumByValue(modeTravailEnum, ao?.modeTravail?.type))}</p>
                                                </div>
                                            </div>
                                            <div className='bottomLignSeparator'>
                                            </div>
                                            <div style={{ display: 'flex', gap: '4px', flexDirection: 'row' }}>
                                                <Button
                                                    variant='text'
                                                    // onClick={async () => {
                                                    //     await postDataSilently({
                                                    //         url: `/ao/addOrDeleteFavoris/${ao?._id}`, payload: {
                                                    //             isAdd:
                                                    //                 !expertAoFav?.includes(ao?._id)
                                                    //         }
                                                    //     })
                                                    //         .then(() => {
                                                    //             refresh();
                                                    //             getMyAOsFavoris();
                                                    //         });
                                                    // }}
                                                    onClick={async () => {
                                                        try {
                                                            const isFavorited = expertAoFav.includes(ao?._id);
                                                            await postDataSilently({
                                                                url: `/ao/addOrDeleteFavoris/${ao?._id}`,
                                                                payload: { isAdd: !isFavorited }
                                                            });

                                                            // Update the local state directly, simulating the API response
                                                            setExpertAoFav((prev) =>
                                                                isFavorited
                                                                    ? prev.filter(id => id !== ao?._id) // Remove from favorites
                                                                    : [...prev, ao?._id]                 // Add to favorites
                                                            );

                                                            // Optionally fetch the latest favorites from API again
                                                            await getMyAOsFavoris();
                                                        } catch (error) {
                                                            console.error('Error updating favorites:', error);
                                                        }
                                                    }}
                                                >
                                                    {(Array.isArray(expertAoFav) && expertAoFav?.includes(ao?._id)) ?
                                                        <Favorite />
                                                        :
                                                        <>
                                                            <FavoriteBorder />
                                                            <p className='textIconsStyle' >{i18n.t('A')}<span style={{textTransform: 'lowercase'}}>{i18n.t('jouter aux favoris')}</span></p>
                                                        </>}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </>
                        ) : <p>{i18n.t('Aucun appel d\'offres à afficher')}</p>
                    }
                </div>
                <div
                    style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignSelf: 'stretch', justifyContent: 'center' }}
                >
                    <Button
                        onClick={gotoPrevious}
                        style={{...buttonStyles()}}
                    >
                        {i18n.t('Précédent')}
                    </Button>
                    {pages.map((pageIndex) => (
                        <Button
                            key={pageIndex}
                            style={{...buttonStyles()}}
                            onClick={() => setPageNumber(pageIndex)}
                            disabled={pageNumber == pageIndex}
                        >
                            {pageIndex + 1}
                        </Button>
                    ))}
                    {
                        pageNumber + 1 !== numberOfPages &&
                        <Button
                            className='btnPrecedStyle'
                            onClick={gotoNext}
                            style={{...buttonStyles()}}
                        >
                            {i18n.t('Suivant')}
                        </Button>
                    }
                </div>
            </div>
        </>
    );
};

export default ListAOsFavoris;
